import __request__ from "routing/request";
export function updateConfig() {
  return __request__("PUT", "/system/authentication/http-header-auth-config", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getConfig() {
  return __request__("GET", "/system/authentication/http-header-auth-config", null, {}, {
    "Accept": ["application/json"]
  });
}
